import { number, object, string, array } from 'yup';
import 'yup-phone';

const registerSchema = object({
  email: string()
    .email('Invalid email address')
    .required('Required')
    .test('no-server-error', '', function () {
      const serverError = this.parent?.email_server_error;
      if (serverError) {
        return this.createError({ message: serverError });
      }
      return true;
    }),
  password: string()
    .required('Required')
    .test('no-server-error', '', function () {
      const serverError = this.parent?.password_server_error;
      if (serverError) {
        return this.createError({ message: serverError });
      }
      return true;
    }),
  first_name: string().required('Required'),
  last_name: string().required('Required'),
  phone: string()
    .phone(undefined, false, 'The phone number is invalid.')
    .required('Required')
    .test('no-server-error', '', function () {
      const serverError = this.parent?.phone_server_error;
      if (serverError) {
        return this.createError({ message: serverError });
      }
      return true;
    }),
  invitation_token: string(),
  provider: string(),
  uid: string(),
  time_zone: string(),
  auth_token: string(),
  email_verification_code: string(),
  step: number().nullable().notRequired(),
  verify_code: string(),
  team_name: string(),
  team_emails: array().of(string()),
  email_server_error: string().optional(),
  password_server_error: string().optional(),
  phone_server_error: string().optional(),
  verify_code_server_error: string().optional(),
});

export default registerSchema;
